<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
        <span v-bind:style="{ color: 'white' }">Grupo</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-6" dense>
        <v-col class="ml-0">
          <v-row dense class="mx-4">
            <v-text-field v-model="modelGrupo.nombre" outlined label="Nombre" dense :dark="dark"
              autocomplete="off"></v-text-field>
          </v-row>

          
          <v-row dense class="mx-4">
            <v-textarea outlined v-model="modelGrupo.descripcion" :dark="dark" label="Descripcion"></v-textarea>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mx-4 mb-2">
        <v-spacer></v-spacer>
        <v-chip class="mr-1 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarGrupo">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
        </v-chip>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";


export default {
  name: "GrupoFormulario",

  data: () => ({
    loading: false,
  }),

  props: {
    modelGrupo: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",
      "provincias",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
  },


  mounted() {

  },

  methods: {
    ...mapActions("grupos", ["getGrupos", "crearGrupo", "updateGrupo"]),

    _cerrarVentana() {
      this.$emit("cerrarFormularioGrupo");
    },

    async _guardarGrupo() {
      this.loading = true;
      if (this.accion == "crear") {
        var res = await this.crearGrupo([
          this.access_token,
          this.modelGrupo,
        ]);
        const params = {};
        this._cerrarVentana();
        await this.getGrupos([this.access_token, false]);
      } else if (this.accion == "editar") {
        var res = await this.updateGrupo([
          this.access_token,
          this.modelGrupo,
        ]);
        this._cerrarVentana();
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.l-map {
  height: 100%;
  width: 100%;
}
</style>
